import React, { Component, createRef } from "react";
import styled from "styled-components";
import { connect } from "react-redux";
import { Redirect, withRouter } from "react-router-dom";
import Toolbar from "../Navigation/Toolbar/Toolbar";
import * as actions from "../../store/actions";
import TooltipButton from "../UI/Buttons/ToolTipButton";
import { Tabs, Tab, Panels } from "../Dashboard/Settings/Tabs/Tabs";
import MediaQuery from "react-responsive";
import DesktopModal from "../UI/Modals/Desktop/DesktopModal";
import Settings from "../Dashboard/Settings/Settings";
import SimpleMobileModal from "../../components/UI/Modals/Mobile/SimpleMobileModal";
import GreyButton from "../UI/Buttons/GreyIconButton";
import DownloadIFrame from "../Dashboard/Meetings/Meeting/OverflowMenu/DownloadFile";
import { SummaryPanel } from "./SummaryPanel";
import TranscriptPanel from "./TranscriptPanel";
import TodolistPanel from "./TodolistPanel";
import OverviewPanel from "./OverviewPanel";
import { SentimentsPanel } from "./SentimentsPanel";
import moment from "moment";
import { PurpleDottedSpinner } from "../UI/Spinners/DottedSpinner";
import SideDrawer from "../Navigation/SideDrawer/SideDrawer";
import Backdrop from "../UI/Backdrop/Backdrop";
import ShareModal from "../Share/ShareModal";
// import { Link } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import SearchPanel from "./SearchPanel";

const CustomSpinner = styled(PurpleDottedSpinner)`
  /* padding: 72px auto; */
  /* left: calc(50% - 25px); */
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  margin: auto;
  margin-top: auto;
  position: absolute;
`;
const PageContainer = styled.div`
  /* border: 1px solid red; */

  height: auto;

  @media (max-width: 768px) {
    /* Adjust the breakpoint based on your design for tablets */
    height: auto;
  }
  /* border: 2px solid green; */
`;
const ContentContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px;
  gap: 3px;
  /* border: 1px solid red; */

  @media (max-width: 768px) {
    /* Adjust the breakpoint based on your design for tablets */
    flex-direction: column;
    justify-content: center;
    padding: 10px 0px;
  }
`;

const MeetingSummaryPage = styled.div`
  display: flex;
  flex-direction: column;
  /* border: 1px solid blue; */
`;
const LeftContentContainer = styled.div`
  /* border: 3px solid pink; */
  width: 50vw;
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  transition: "width 4s";
  @media (max-width: 768px) {
    /* Adjust the breakpoint based on your design for tablets */
    width: 100vw;
  }
`;
const RightContentContainer = styled.div`
  /* border: 3px solid orange; */
  width: 50vw;
  height: 100%;
  transition: "width 4s";
  @media (max-width: 768px) {
    /* Adjust the breakpoint based on your design for tablets */
    width: 100vw;
  }
`;

const MeetingDetailsBar = styled.div`
  background: #ffffff;
  width: 100%;
  // border: 1px solid red;
  display: flex;
  padding: 20px;
  justify-content: space-between;
  min-height: 100px;
  margin-bottom: 10px;
`;

const SearchResultConatainer = styled.div`
  display: flex;
  position: absolute;
  z-index: 10;
  width: 100%;
`;

const MeetingAndHostContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 80%;
`;
const MeetingName = styled.div`
  font-size: 1.5vw;
  font-weight: 600;
  width: 100%;
  height: auto;
  @media (max-width: 768px) {
    /* Adjust the breakpoint based on your design for tablets */
    font-size: 3vw;
  }
`;
const HostName = styled.div`
  font-size: 1.2vw;
  font-weight: 400;
  width: 100%;
  color: grey;
  height: auto;
  @media (max-width: 768px) {
    /* Adjust the breakpoint based on your design for tablets */
    font-size: 2.5vw;
  }
`;

const Link = styled.div`
  text-decoration: underline;
  cursor: pointer;
  color: blue;
`;
const VideoContainer = styled.div`
  position: relative;
  overflow: hidden;
  padding-bottom: 56.25%; /* 16:9 aspect ratio (9 / 16 * 100) */
  margin: 0px 0px 10px 0px;
`;
const Video = styled.video`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
`;
const SettingsContainer = styled.div`
  height: 100%;

  background: transparent;
  /* border: 1px solid rgba(23, 15, 48, 0.25); */
  border-bottom: 0px;
  border-radius: 3px;
`;

const VerticalLine = styled.div`
  height: 50%;
  width: 0.5px;
  background: #85808073;
`;

class SingleMeetingView extends Component {
  state = {
    showSideDrawer: false,
    showLeftContainer: true,
    showRightContainer: true,
    windowWidth: window.innerWidth,
    isOpen: false,
    downloadVideoClicked: false,
    primaryTab: "Overview",
    secondaryTab: "TodoList",
    userIsHost: false,
    transcriptParts: [],
    displayShareModal: false,
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    this.props.clearSpecificMeetingStates();
    this.props.clearMeetingNotesStates();
    this.getAllMeetingDetails();
    window.addEventListener("resize", this.handleResize);
  }
  componentDidUpdate(prevProps) {
    if (
      this.props.accessToken !== prevProps.accessToken ||
      this.props.match.params.meetingId !== prevProps.match.params.meetingId
    ) {
      this.getAllMeetingDetails();
    }
  }
  componentWillUnmount() {
    this.props.clearSpecificMeetingStates();
    this.props.clearMeetingNotesStates();
    window.removeEventListener("resize", this.handleResize);
  }
  handleResize = () => {
    this.setState({ windowWidth: window.innerWidth });
  };
  // this controls the width for different screen sizes
  getContainerStyles = (containerType) => {
    const { windowWidth, showLeftContainer, showRightContainer } = this.state;
    let baseWidth;

    if (containerType === "left") {
      baseWidth = showRightContainer ? "50vw" : "100%";
    } else if (containerType === "right") {
      baseWidth = showLeftContainer ? "50vw" : "100%";
    }

    if (windowWidth <= 768) {
      // for mobile devices
      return { width: "100%" };
    } else if (windowWidth <= 1024) {
      // for tablets
      return {
        width: showLeftContainer && showRightContainer ? "50vw" : "100%",
      };
    } else {
      // for larger screens
      return { width: baseWidth };
    }
  };
  sideDrawerClosedHandler = () => {
    this.setState({ showSideDrawer: !this.state.showSideDrawer });
  };
  sideDrawerToggleHandler = () => {
    this.setState((prevState) => {
      return { showSideDrawer: !prevState.showSideDrawer };
    });
  };
  sideDrawerOpenHandler = () => {
    this.setState({ showSideDrawer: true });
  };
  sideDrawerCloseHandler = () => {
    this.setState({ showSideDrawer: false });
  };
  settingsOpen = () => {
    this.setState({ isOpen: true });
  };

  settingsClose = () => {
    this.setState({ isOpen: false });
  };

  settingsMobile = () => {
    this.setState({ isOpen: true });
    this.setState({ showSideDrawer: false });
  };

  userIsHost = () => {
    this.props.host?.emails?.email === this.props.userEmail
      ? this.setState({ userIsHost: true })
      : this.setState({ userIsHost: false });
  };
  getAllMeetingDetails = async () => {
    const { meetingId } = this.props.match.params;
    const { accessToken } = this.props;
    if (accessToken) {
      try {
        this.props.getSpecificMeeting(accessToken, meetingId);
      } catch (error) {
        console.error("Error in getSpecificMeeting:", error);
        // Handle error if needed
      }

      try {
        this.props.getMeetingRecording(accessToken, meetingId);
      } catch (error) {
        console.error("Error in getMeetingRecording:", error);
        // Handle error if needed
      }

      try {
        this.props.getMeetingNotes(accessToken, meetingId);
      } catch (error) {
        console.error("Error in getMeetingNotes:", error);
        // Handle error if needed
      }

      try {
        this.props.getTranscriptSpeakerNames(accessToken, meetingId);
      } catch (error) {
        console.error("Error in getTranscriptSpeakerNames:", error);
        // Handle error if needed
      }

      try {
        this.props.getSentimentsData(accessToken, meetingId);
      } catch (error) {
        console.error("Error in getSentimentsData:", error);
        // Handle error if needed
      }
      try {
        await this.props.downloadTranscript(accessToken, meetingId);
      } catch (error) {
        console.error("Error in downloadTranscript:", error);
        // Handle error if needed
      }
      this.setState({
        transcriptParts: this.getTranscriptContentWithClickableTimestamps(
          this.props.transcriptContent
        ),
      });
      this.userIsHost();
    }
  };

  changePrimaryTab = (tab) => {
    this.setState({
      primaryTab: tab,
    });
  };
  changeSecondaryTab = (tab) => {
    this.setState({
      secondaryTab: tab,
    });
  };

  onShareOptionClick = () => {
    this.setState({ displayShareModal: true });
  };

  onRequestCloseShareModal = () => {
    this.setState({ displayShareModal: false });
  };

  getTranscriptContentWithClickableTimestamps = (transcriptContent) => {
    const transcriptParts = [];
    const timestampRegex = /\d+:\d+:\d+/g;

    if (transcriptContent) {
      let timestampMatches = transcriptContent.matchAll(timestampRegex);
      let i = 0;
      let currentIndex = 0;
      for (const timestampMatch of timestampMatches) {
        const seconds = moment
          .duration(timestampMatch[0], "HH:mm:ss")
          .asSeconds();
        transcriptParts.push(
          transcriptContent.slice(currentIndex, timestampMatch.index)
        );
        transcriptParts.push(
          <Link
            ref={createRef()}
            key={"ts_" + seconds}
            style={{ float: "left" }}
            onClick={() => this.forwardMeeting(this.props.meetingId, seconds)}
          >
            {timestampMatch[0]}
          </Link>
        );
        currentIndex = timestampMatch.index + timestampMatch[0].length;
        i = i + 1;
      }
      transcriptParts.push(transcriptContent.slice(currentIndex));
    }

    return transcriptParts;
  };
  forwardMeeting = async (meetingId, seconds) => {
    document.getElementById("videoContainer").scrollIntoView({
      behavior: "smooth",
    });
    this.props.getMeetingRecording(this.props.accessToken, meetingId, seconds);
  };
  onShareOptionClick = () => {
    this.setState({ displayShareModal: true });
  };

  onRequestCloseShareModal = () => {
    this.setState({ displayShareModal: false });
  };
  render() {
    const name =
      this.props.firstName && this.props.lastName
        ? `${this.props.firstName} ${this.props.lastName}`
        : "Loading...";
    const meetingData = [
      {
        id: this.props.meetingId,
        name: this.props.meetingName,
      },
    ];
    const meetingVideoAndDetailBar = () => (
      <MeetingSummaryPage className="eigth-step">
        <ShareModal
          isOpen={this.state.displayShareModal}
          shouldCloseOnOverlayClick={true}
          onRequestClose={this.onRequestCloseShareModal}
          meetingData={meetingData}
        ></ShareModal>
        <VideoContainer id="videoContainer">
          {this.props.videoUrl ? (
            <Video key={this.props.videoUrl} controls>
              <source src={this.props.videoUrl} type="video/mp4" />
            </Video>
          ) : (
            <CustomSpinner size={50} />
          )}
        </VideoContainer>
        <MeetingDetailsBar>
          <MeetingAndHostContainer>
            <MeetingName>{this.props.meetingName}</MeetingName>

            {this.props.host && (
              <HostName>
                Host : {this.props.host.name}{" "}
                {this.state.userIsHost ? "( You )" : null}
              </HostName>
            )}
          </MeetingAndHostContainer>
          <GreyButton
            style={{ width: "auto", height: "40px", margin: "0px 10px" }}
            text={"Download"}
            iconName={"download"}
            disabled={this.state.downloadVideoClicked}
            onClick={() => {
              this.setState({ downloadVideoClicked: true });
              setTimeout(() => {
                this.setState({ downloadVideoClicked: false });
              }, 10000);
            }}
          />
          {this.state.downloadVideoClicked && (
            <DownloadIFrame url={this.props.videoUrl} />
          )}
          <GreyButton
            style={{ width: "auto", height: "40px", margin: "0px 10px" }}
            text={"Share"}
            className="ninth-step"
            iconName={"share"}
            onClick={this.onShareOptionClick}
            disabled={this.state.userIsHost ? false : true}
            title={this.state.userIsHost ? "Share Now" : "Only host can share"}
          />
        </MeetingDetailsBar>
      </MeetingSummaryPage>
    );
    const primarySettingsContainer = () => (
      <SettingsContainer className="eleventh-step">
        <Tabs
          style={{
            width: "100%",
            height: "48px",
            alignItems: "center",
            backgroundColor: "white",
          }}
        >
          <Tab
            style={{ width: "100%", height: "95%" }}
            onClick={() => this.changePrimaryTab("Overview")}
            selected={this.state.primaryTab === "Overview"}
          >
            Overview
          </Tab>
          <VerticalLine />
          <Tab
            style={{ width: "100%", height: "95%" }}
            onClick={() => this.changePrimaryTab("Transcript")}
            selected={this.state.primaryTab === "Transcript"}
          >
            Transcript
          </Tab>
        </Tabs>
        <Panels
          style={{
            position: "relative",
            minHeight: "500px",
            backgroundColor: "transparent",
          }}
        >
          {this.state.primaryTab === "Overview" &&
            (!this.props.meetingNotes.loading ? (
              <OverviewPanel description={this.props.overview} />
            ) : (
              <CustomSpinner size={50} />
            ))}
          {this.state.primaryTab === "Transcript" &&
            (this.props.meetingTranscript.loading ? (
              <CustomSpinner size={50} />
            ) : (
              <TranscriptPanel
                transcriptParts={this.state.transcriptParts}
                speakerNames={this.props.speakerNames}
                userIsHost={this.state.userIsHost}
              // description={this.props.transcript}
              />
            ))}
        </Panels>
      </SettingsContainer>
    );

    const secondarySettingsContainer = () => (
      <SettingsContainer className="tenth-step">
        <Tabs
          style={{
            width: "100%",
            height: "48px",
            alignItems: "center",
            backgroundColor: "white",
          }}
        >
          <Tab
            style={{ width: "100%", height: "95%" }}
            onClick={() => this.changeSecondaryTab("TodoList")}
            selected={this.state.secondaryTab === "TodoList"}
          >
            TodoList
          </Tab>
          <VerticalLine />
          <Tab
            style={{ width: "100%", height: "95%" }}
            onClick={() => this.changeSecondaryTab("Summary")}
            selected={this.state.secondaryTab === "Summary"}
          >
            Summary
          </Tab>
          <VerticalLine />
          <Tab
            style={{ width: "100%", height: "95%" }}
            onClick={() => this.changeSecondaryTab("Sentiments")}
            selected={this.state.secondaryTab === "Sentiments"}
          >
            Sentiments
          </Tab>
        </Tabs>
        <Panels
          style={{
            // minHeight: "calc(100vh + 360px)",
            minHeight: "500px",
            position: "relative",
            backgroundColor: "transparent",
          }}
        >
          {this.state.secondaryTab === "TodoList" &&
            (!this.props.meetingNotes.loading ? (
              <TodolistPanel
                userIsHost={this.state.userIsHost}
                meetingNotes={this.props.meetingNotes}
              />
            ) : (
              <CustomSpinner size={50} />
            ))}
          {this.state.secondaryTab === "Summary" &&
            (!this.props.meetingNotes.loading ? (
              <SummaryPanel
                description={this.props.summary}
                overview={this.props.overview}
              />
            ) : (
              <CustomSpinner size={50} />
            ))}
          {this.state.secondaryTab === "Sentiments" &&
            (this.props.meetingNotes ? (
              <SentimentsPanel
                sentimentsData={this.props.meetingNotes.sentimentsData}
              />
            ) : (
              <CustomSpinner size={50} />
            ))}
        </Panels>
      </SettingsContainer>
    );

    return this.props.isAuthenticated ? (
      <PageContainer>
        <SideDrawer
          show={this.state.showSideDrawer}
          closed={this.sideDrawerClosedHandler}
          showSettings={this.settingsMobile}
        />
        <Backdrop
          show={this.state.showSideDrawer}
          closed={this.sideDrawerClosedHandler}
        />
        <Toolbar
          name={name}
          toggle={this.sideDrawerToggleHandler}
          sideDrawerOpener={this.sideDrawerOpenHandler}
          sideDrawerCloser={this.sideDrawerCloseHandler}
          showSettings={this.settingsOpen}
        />
        <div style={{ zIndex: 100 }}>
          <MediaQuery query="(min-width: 769px)">
            {(matches) => {
              if (matches) {
                return (
                  <DesktopModal
                    isOpen={this.state.isOpen}
                    onRequestClose={this.settingsClose}
                    width="30%"
                    top="10%"
                    padding="0px"
                    maxWidth="560px"
                    minWidth="320px"
                    zIndex="100"
                  >
                    <Settings
                      zoom_integrated={this.props.zoom_integrated}
                      zoom_refresh_token_exists={
                        this.props.zoom_refresh_token_exists
                      }
                      webex_integrated={this.props.webex_integrated}
                      webex_refresh_token_exists={
                        this.props.webex_refresh_token_exists
                      }
                    />
                  </DesktopModal>
                );
              } else {
                return (
                  <SimpleMobileModal
                    isOpen={this.state.isOpen}
                    onRequestClose={this.settingsClose}
                    zIndex="100"
                  >
                    <Settings
                      zoom_integrated={this.props.zoom_integrated}
                      zoom_refresh_token_exists={
                        this.props.zoom_refresh_token_exists
                      }
                      webex_integrated={this.props.webex_integrated}
                      webex_refresh_token_exists={
                        this.props.webex_refresh_token_exists
                      }
                    />
                  </SimpleMobileModal>
                );
              }
            }}
          </MediaQuery>
        </div>

        <ContentContainer>
          {this.state.showLeftContainer && (
            <LeftContentContainer style={this.getContainerStyles("left")}>
              {/* <SearchResultConatainer>
                <SearchPanel meetingId={this.props.meetingId} />
              </SearchResultConatainer> */}
              {meetingVideoAndDetailBar()}
              {primarySettingsContainer()}
            </LeftContentContainer >
          )
          }

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              height: "fit-content",
              gap: "4px",
            }}
          >
            {this.state.showRightContainer && this.state.windowWidth > 768 && (
              <TooltipButton
                tooltipText={
                  this.state.showLeftContainer
                    ? "Close Left Panel"
                    : "Open Left Panel"
                }
              >
                <GreyButton
                  style={{
                    width: "fit-content",
                    height: "auto",
                    border: "1px solid white",
                    padding: "0.5px",
                    borderRadius: "50%",
                    backgroundColor: "#c3c3c3",

                    transform: `${this.state.showLeftContainer
                      ? "rotate(90deg)"
                      : "rotate(270deg)"
                      }`,
                    transition: "transform 1s",
                  }}
                  iconName={"down_arrow"}
                  disabled={this.state.downloadVideoClicked}
                  onClick={() => {
                    this.setState({
                      showLeftContainer: !this.state.showLeftContainer,
                    });
                  }}
                />
              </TooltipButton>
            )}
            {this.state.showLeftContainer && this.state.windowWidth > 768 && (
              <TooltipButton
                tooltipText={
                  this.state.showRightContainer
                    ? "Close Right Panel"
                    : "Open Right Panel"
                }
              >
                <GreyButton
                  style={{
                    width: "fit-content",
                    height: "auto",
                    border: "1px solid white",
                    padding: "0.5px",
                    borderRadius: "50%",
                    backgroundColor: "#c3c3c3",
                    transform: `${this.state.showRightContainer
                      ? "rotate(270deg)"
                      : "rotate(90deg)"
                      }`,
                    transition: "transform 1s",
                  }}
                  iconName={"down_arrow"}
                  disabled={this.state.downloadVideoClicked}
                  onClick={() => {
                    this.setState({
                      showRightContainer: !this.state.showRightContainer,
                    });
                  }}
                />
              </TooltipButton>
            )}
          </div>
          {
            this.state.showRightContainer && (
              <RightContentContainer style={this.getContainerStyles("right")}>
                {secondarySettingsContainer()}
              </RightContentContainer>
            )
          }
        </ContentContainer >
      </PageContainer >
    ) : (
      <Redirect to="/auth/login" />
    );
  }
}

// export default SpecificMeetingView;

// Map dispatch functions to component props
const mapDispatchToProps = (dispatch) => {
  return {
    getSpecificMeeting: (accessToken, meetingId) =>
      dispatch(actions.getSpecificMeeting(accessToken, meetingId)),
    getMeetingRecording: (accessToken, meetingId, seconds) =>
      dispatch(actions.getMeetingRecording(accessToken, meetingId, seconds)),

    deleteMeeting: (accessToken, meetingId, meetings) =>
      dispatch(actions.deleteMeeting(accessToken, meetingId, meetings)),
    getTranscriptUrl: (accessToken, meetingId) =>
      dispatch(actions.getTranscriptUrl(accessToken, meetingId)),
    getTranscriptSpeakerNames: (accessToken, meetingId) =>
      dispatch(actions.getTranscriptSpeakerNames(accessToken, meetingId)),

    getSentimentsData: (accessToken, meetingId) =>
      dispatch(actions.getSentimentsData(accessToken, meetingId)),

    downloadMeeting: (accessToken, meetingId) =>
      dispatch(actions.downloadMeetingRecording(accessToken, meetingId)),
    downloadTranscript: (accessToken, meetingId) =>
      dispatch(actions.downloadTranscript(accessToken, meetingId)),
    getMeetingNotes: (accessToken, meetingId) =>
      dispatch(actions.getMeetingNotes(accessToken, meetingId)),

    updateSpeakerNames: (accessToken, meetingId, speakerNames) =>
      dispatch(
        actions.updateSpeakerNames(accessToken, meetingId, speakerNames)
      ),
    viewMeetingRecording: (accessToken, meetingId, modalType, seconds) =>
      dispatch(
        actions.viewMeetingRecording(accessToken, meetingId, modalType, seconds)
      ),
    clearSpecificMeetingStates: () =>
      dispatch(actions.clearSpecificMeetingStates()),
    clearMeetingNotesStates: () => dispatch(actions.clearMeetingNotesStates()),
  };
};
// Map Redux state to component props
const mapStateToProps = (state) => {
  return {
    isAuthenticated: state.auth.accessToken !== null,
    meetingModal: state.meetingModal,
    meetingDownload: state.meetingDownload,
    meetingTranscript: state.meetingTranscript,
    meetingNotes: state.meetingNotes,
    firstName: state.user.firstName,
    lastName: state.user.lastName,
    accessToken: state.auth.accessToken,
    userEmail: state.user.email,
    meetingId: state.specificMeeting.meetingId,
    meetingName: state.specificMeeting.meetingName,
    attendees: state.specificMeeting.attendees,
    host: state.specificMeeting.host,
    videoUrl: state.specificMeeting.videoUrl,
    loading: state.specificMeeting.loading,
    summary: state.meetingNotes.summary,
    overview: state.meetingNotes.overview,
    todoList: state.meetingNotes.actionItems,
    sentiments: state.meetingNotes.sentiment,
    transcriptContent: state.meetingTranscript.content,
    speakerNames: state.meetingTranscript.speakerNames,
  };
};
// Connect the component to the Redux store
export default connect(mapStateToProps, mapDispatchToProps)(SingleMeetingView);
